import { useEffect, useState } from "react";
import { ArrowUpRight, FileText, Newspaper, Play, Mic, BookOpen } from "lucide-react";
import api from "../lib/api";
import { usePageMeta, usePageJsonLd } from "../hooks/usePageMeta";
import { breadcrumb, graph } from "../lib/schema";

const typeIcon = {
  article: Newspaper,
  interview: Mic,
  talk: BookOpen,
  video: Play,
  publication: FileText,
};

const Media = () => {
  usePageMeta({
    title: "Media & Publications | Dr. Shantanu Kumar Gupta",
    path: "/media",
    description: "Press interviews, YouTube videos, conference talks and peer-reviewed publications by Dr. Shantanu Kumar Gupta, Varanasi.",
  });
  usePageJsonLd(graph([breadcrumb([{ name: "Home", path: "/" }, { name: "Media", path: "/media" }])]));
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/media").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="media-page">
      <section className="pt-20 pb-10 container-page">
        <div className="overline mb-4">Media & Publications</div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-balance max-w-3xl">
          In the press, on the podium.
        </h1>
      </section>
      <section className="py-8 container-page grid md:grid-cols-2 gap-6" data-testid="media-list">
        {items.map((m) => {
          const Icon = typeIcon[m.type] || Newspaper;
          return (
            <a key={m.title} href={m.link} target="_blank" rel="noopener noreferrer" className="card-elegant p-8 block group" data-testid={`media-${m.title.slice(0, 20).replace(/\s/g, "-").toLowerCase()}`}>
              <div className="flex items-center gap-3 text-[hsl(var(--accent))]">
                <Icon size={20} strokeWidth={1.5} />
                <span className="text-xs uppercase tracking-[0.22em]">{m.type} · {m.outlet}</span>
              </div>
              <h3 className="font-serif text-2xl mt-4 leading-tight">{m.title}</h3>
              <p className="mt-3 text-sm text-muted-foreground">{m.summary}</p>
              <div className="mt-5 flex justify-between items-center text-xs uppercase tracking-[0.22em] text-[hsl(var(--primary))]">
                <span>{m.date}</span>
                <ArrowUpRight size={14} className="group-hover:translate-x-1 -translate-y-0.5 transition-transform" />
              </div>
            </a>
          );
        })}
      </section>
    </div>
  );
};

export default Media;
